import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { TrendingUp, Building, Handshake } from "lucide-react";

export default function Investor() {
  const [f, setF] = useState({ name: "", phone: "", email: "", city: "", investment_budget: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads/investor", f);
      toast.success("Thanks — our investor team will reach out via WhatsApp.");
      setF({ name: "", phone: "", email: "", city: "", investment_budget: "", message: "" });
      setTimeout(() => window.open("https://wa.me/919000100001?text=I%20submitted%20investor%20interest%20on%20HAMMAM%20OS", "_blank"), 800);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="investor-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <div>
        <div className="label-eyebrow mb-4">Franchise · Investment</div>
        <h1 className="text-5xl lg:text-6xl font-heading text-white mb-8">Own a<br/>Hammam.</h1>
        <p className="text-hsecondary leading-relaxed mb-10">
          We're expanding to ten branches over the next five years, in select cities across India and the GCC. We partner with committed investors who share our obsession with craft and hospitality.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { icon: TrendingUp, t: "18-24 mo", d: "Payback period" },
            { icon: Building, t: "3-5 Cr", d: "Investment range" },
            { icon: Handshake, t: "Full support", d: "Ops · training · marketing" },
          ].map((f, i) => (
            <div key={i} className="border border-white/10 p-5">
              <f.icon className="text-hgold mb-3" size={18} />
              <div className="font-heading text-2xl text-white">{f.t}</div>
              <div className="label-eyebrow mt-1 text-white/50">{f.d}</div>
            </div>
          ))}
        </div>
      </div>
      <form onSubmit={submit} className="border border-white/10 p-8 space-y-4" data-testid="investor-form">
        <input required placeholder="Full Name" data-testid="investor-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
        <div className="grid grid-cols-2 gap-4">
          <input required placeholder="Phone" data-testid="investor-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
          <input required type="email" placeholder="Email" data-testid="investor-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <input required placeholder="City" data-testid="investor-city" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
          <select required data-testid="investor-budget" value={f.investment_budget} onChange={(e) => setF({ ...f, investment_budget: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none">
            <option value="">Budget</option>
            <option>Under 3 Cr</option>
            <option>3-5 Cr</option>
            <option>5-8 Cr</option>
            <option>8+ Cr</option>
          </select>
        </div>
        <textarea rows="4" placeholder="Anything we should know?" data-testid="investor-message" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none resize-none" />
        <button type="submit" disabled={busy} data-testid="investor-submit" className="gold-btn w-full justify-center">{busy ? "Submitting..." : "Register interest"}</button>
      </form>
    </div>
  );
}
